import { render, staticRenderFns } from "./Local.vue?vue&type=template&id=524b568c&"
import script from "./Local.vue?vue&type=script&lang=ts&"
export * from "./Local.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports